// ticket-típus badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `ticketType` fogalom):
// support → secondary · bug → danger · feature_request → violet · billing → brand · other → muted, mindegyik
// vezető ikonnal. ez a fájl csak a kényelmes, névre szóló API-t tartja meg.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface TicketTypeBadgeProps {
  /** A nyers típus-string (a jel forrása). */
  type: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('tickets.typeLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function TicketTypeBadge({ type, label, className }: TicketTypeBadgeProps): JSX.Element {
  return <DomainBadge kind="ticketType" value={type} label={label} className={className} />;
}
